export const downloadAndRename = ({ blob, filename }) => {
    
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    a.click();

}